// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_o2-0";